import { requestUrl } from "@/config/config";


// 合作商管理
export const getPartnerList = `${requestUrl}/manage/externalSystem/list`;

// 新增合作商
export const addPartner = `${requestUrl}/manage/externalSystem/add`;

// 编辑合作商
export const eidtPartner = `${requestUrl}/manage/externalSystem/editSystem`;

// 删除合作商
export const delPartner = `${requestUrl}/manage/externalSystem/remove`;

// 合作商详情
export const getPertnerDetail = `${requestUrl}/manage/externalSystem/queryById`;

// 修改额度
export const changeCredit = `${requestUrl}/manage/externalSystem/changeCredit`;

// 修改额度
export const getCreditList = `${requestUrl}/manage/copyrightRecord/list`;



